import { TotalAllocatedBudgets } from '../../lib/types/models/budget-line/total-allocated-budgets'
import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTotalAllocatedBudgets() {
  return restApiClient
    .url(API.budgetAllocation.getTotalAllocatedBudgets.url)
    .get<TotalAllocatedBudgets[]>()
}
